var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-792.000000, -558.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(792.000000, 558.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0,
    enableBackground: "new",
    cx: 512,
    cy: 512,
    r: 512
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M254.4058685,725.4285889c-36.8134613,0-51.5697937-25.0029907-32.8695526-55.9943237 l250.6958313-432.7871399c18.6600952-30.9248047,48.8739319-30.9913177,67.5741882,0l250.6958008,432.7871399 c18.6600952,30.9248047,3.8300171,55.9943237-32.8695068,55.9943237H254.4058685z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.4285583,390.1904907c0-17.5491638,16.4147034-30.4761963,36.5714417-30.4761963 c20.197876,0,36.5714111,12.8581543,36.5714111,30.4761963v121.9047852 c0,17.5491333-16.4146729,30.4761353-36.5714111,30.4761353c-20.1978455,0-36.5714417-12.8581543-36.5714417-30.4761353 V390.1904907z M469.4285583,627.9047241c0-32.3883057,16.4147034-48.7618408,48.7619324-48.7618408 c8.0073853,0,24.3809204,16.4146729,24.3809204,48.7618408c0,8.0073853-16.4146729,24.3809814-24.3809204,24.3809814 C485.8021545,652.2857056,469.4285583,635.8710327,469.4285583,627.9047241z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.6a4ff51a1b9d3b2cb55a288995e11c09.svg";
export { ForwardRef as ReactComponent };